module.exports = __webpack_public_path__ + "img/blue-logo.c02a9c0c.svg";